import React, { useEffect, useState } from "react";
import "./Payment_Summary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faTags, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Green_Btn from "../../../../../../Common-Component/common_btn/green_btn/Green_Btn";
import Coupon_Card from "../../../../../../Common-Component/coupon_card/Coupon_Card";
import {
  CartCalculation,
  getCart,
  OrderCalculation,
} from "../../../../../../../utils/apis/addToCart/addToCart";

const Payment_Summary = ({
  viewAllSummary,
  isCheckoutPage,
  checkout_btn,
  checkoutAction,
  setcartSummary,
  cartSummary,
  product_id,
  user_id,
  errorOrder,
}) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [error, setError] = useState("");
  const [applyCoupons, setApplyCoupons] = useState([]);

  const [summary, setSummary] = useState({
    qty: 0,
    cartTotal: 0,
    gst: 0,
    delivery: 0,
    discount: 0,
    grandTotal: 0,
    code_id: null,
  });

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    const res = await getCart();

    if (res?.success) {
      let qty = 0;
      let total = 0;
      let gst = 0;
      let delivery = 0;

      res.data.forEach((item) => {
        const price = Number(item.product_variant.s_price);
        const quantity = Number(item.quantity);

        qty += quantity;
        total += price * quantity;

        const tax = Number(
          item.product?.product_detail?.tax_percentage?.name || 0
        );
        gst += (price * quantity * tax) / 100;

        const deliveryCharge = Number(item.product?.delivery_charges || 0);
        delivery += deliveryCharge;
      });

      setSummary((prev) => ({
        ...prev,
        qty,
        cartTotal: total,
        gst,
        delivery,
        grandTotal: total + gst + delivery - prev.discount,
      }));
    }
  };

  const onCouponApply = ({ discountAmount, code_id }) => {
    setSummary((prev) => ({
      ...prev,
      discount: discountAmount,
      code_id,
      grandTotal: prev.cartTotal + prev.gst + prev.delivery - discountAmount,
    }));
  };

  useEffect(() => {
    if (summary.grandTotal > 0) {
      localStorage.setItem(
        "paymentSummary",
        JSON.stringify({ finalAmount: summary.grandTotal })
      );
    }
  }, [summary.grandTotal]);

  const OrderCalculationdata = async (applyCoupons) => {
    const res = await OrderCalculation(applyCoupons, user_id, product_id);
    if (res?.success) {
      setcartSummary(res?.data);
    }
  };

  useEffect(() => {
    OrderCalculationdata(applyCoupons);
  }, [applyCoupons]);

  return (
    <>
      <div className="payment_summary_div">
        {!viewAllSummary && (
          <h3 className="heading">
            <img src="/assets/Image/cart/icon.png" className="icon_img" />{" "}
            Payment Summary <span className="inner_text">(incl GST)</span>
          </h3>
        )}

        <div className="summary">
          <div className="row-divider">
            <div className="title_div">
              <p>Total no. of items</p>
            </div>
            <div className="qty_div">
              <p>{Number(cartSummary?.totals?.no_of_item)} Nos.</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Sub Total</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(cartSummary?.totals?.total_selling).toFixed(2)}</p>
            </div>
          </div>

         
          <div className="row-divider">
            <div className="title_div">
              <p>Offer Discount</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(cartSummary?.totals?.offer_discount).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Coupon Discount</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(cartSummary?.totals?.coupon_discount).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>GST</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(cartSummary?.totals?.total_tax).toFixed(2)}</p>
            </div>
          </div>
           <div className="row-divider">
            <div className="delivery_title_div">
              <p>
                Delivery Charges
                {/* - <span className="inner_title">Free Delivery</span> */}
              </p>
            </div>
            <div className="qty_div">
              <p>
                ₹{" "}
                {Number(cartSummary?.totals?.total_delivery_charges).toFixed(2)}
              </p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Total Addon</p>
            </div>
            <div className="qty_div">
              <p>₹ {Number(cartSummary?.totals?.total_addon).toFixed(2)}</p>
            </div>
          </div>

          <div className="total_div">
            <div className="row">
              <div className="col-6">
                <div className="total_title_div">
                  <p>Grand Total</p>
                </div>
              </div>
              <div className="col-6">
                <div className="total_qty_div">
                  <p>
                    ₹ {Number(cartSummary?.totals?.total_amount).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isCheckoutPage && (
        <div className="payment_summary_div coupon_main_div">
          <div className="coupon_div">
            <div className="special_div">
              <img
                src="/assets/Image/checkout/green_discount.png"
                className="discount_img"
              />
              <p className="special_text">Something Special for you!</p>
            </div>

            <div className="coupons_div">
              <div className="left_side">
                <FontAwesomeIcon icon={faTags} className="tag_icon" />
                <span className="coupon_text">Coupons</span>
              </div>
              <div className="btn_holder">
                <button
                  className="black_btn"
                  onClick={() => setShowOffCanvas(true)}
                >
                  View
                </button>
              </div>
            </div>
          </div>
          {errorOrder && <p style={{ color: "red" }}>{errorOrder}</p>}

          <div className="checkout_btn">
            <Green_Btn btn_name={checkout_btn} onClick={checkoutAction} />
          </div>
        </div>
      )}

      <Offcanvas
        className="right_bottom_offcanvas"
        placement="bottom"
        show={showOffCanvas}
        onHide={() => setShowOffCanvas(false)}
      >
        <div className="white_card">
          <Offcanvas.Header className="d-flex justify-content-between">
            <Offcanvas.Title>
              <FontAwesomeIcon icon={faTags} className="tag_icon" /> Coupons
            </Offcanvas.Title>

            <div
              className="icon_holder"
              onClick={() => setShowOffCanvas(false)}
            >
              <FontAwesomeIcon icon={faXmark} className="close_icon" />
            </div>
          </Offcanvas.Header>
          <p style={{ color: "red" }}>{error}</p>
          <Offcanvas.Body>
            <div className="coupon_cards_div">
              <Coupon_Card
                setError={setError}
                error={error}
                applyCoupons={applyCoupons}
                setApplyCoupons={setApplyCoupons}
                showtc
                orderAmount={summary.cartTotal}
                onApplyCoupon={onCouponApply}
              />
            </div>
          </Offcanvas.Body>
        </div>
      </Offcanvas>
    </>
  );
};

export default Payment_Summary;
